export default __webpack_public_path__ + "static/media/Punto_12_Cantina_Palio_Marinaro_FRA_Def.7fd55c44.aac";